'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _chemist = require('chemist');

var _lodash = require('lodash');

var _reactI18next = require('react-i18next');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _localisedPaths = require('../../helpers/localisedPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderTable = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _chemist.configurable)(), _dec3 = (0, _reactCssModules2.default)(_style2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(OrderTable, _React$Component);

  function OrderTable() {
    (0, _classCallCheck3.default)(this, OrderTable);
    return (0, _possibleConstructorReturn3.default)(this, (OrderTable.__proto__ || (0, _getPrototypeOf2.default)(OrderTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(OrderTable, [{
    key: 'renderTableRow',
    value: function renderTableRow(order) {
      if (order.state !== 'complete') {
        return '';
      }

      var date = new Date(order.completedAt);
      var formattedDate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
      var lng = this.props.params.lng;

      return _react2.default.createElement(
        'tr',
        { styleName: 'o-orderTable__row', key: (0, _lodash.uniqueId)() },
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'a',
            {
              href: (0, _localisedPaths.localisedAction)(this.props.config.store, 'orders/' + order.number + '/view', lng),
              styleName: 'o-orderTable__link'
            },
            order.number
          )
        ),
        _react2.default.createElement(
          'td',
          null,
          order.state === 'complete' ? formattedDate : ''
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.capitalize)(order.state)
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.capitalize)(order.paymentState)
        ),
        _react2.default.createElement(
          'td',
          null,
          (0, _lodash.capitalize)(order.shipmentState)
        ),
        _react2.default.createElement(
          'td',
          null,
          order.displayTotal
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          orders = _props.orders;


      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-md-10 col-md-offset-1' },
          _react2.default.createElement(
            'table',
            { styleName: 'o-orderTable', className: 'order-summary' },
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  { styleName: 'o-orderTable__heading' },
                  t('spree.order')
                ),
                _react2.default.createElement(
                  'th',
                  { styleName: 'o-orderTable__heading' },
                  t('spree.order_date')
                ),
                _react2.default.createElement(
                  'th',
                  { styleName: 'o-orderTable__heading' },
                  t('spree.status')
                ),
                _react2.default.createElement(
                  'th',
                  { styleName: 'o-orderTable__heading' },
                  t('spree.payment_state')
                ),
                _react2.default.createElement(
                  'th',
                  { styleName: 'o-orderTable__heading' },
                  t('spree.shipment_state')
                ),
                _react2.default.createElement(
                  'th',
                  { styleName: 'o-orderTable__heading' },
                  t('spree.total')
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              (0, _lodash.map)(orders, this.renderTableRow.bind(this))
            )
          )
        )
      );
    }
  }]);
  return OrderTable;
}(_react2.default.Component), _class2.propTypes = {
  orders: _react.PropTypes.array
}, _class2.defaultProps = {
  orders: []
}, _temp)) || _class) || _class) || _class);
exports.default = OrderTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/OrderTable/index.js
// module id = 2297
// module chunks = 0